<template>
  <section class="content">
    <admin-header
      :title="'Financial Profiles'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminFinancialProfile',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Financial Profiles',
        searchEntityScreen: 'Admin - Financial Profile search',
        filterEventName: 'admin-financial-profile-filter',
        filterName: 'FinancialProfileFilter',
        entityName: 'financial-profile'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminFinancialProfile.vue?92a8c76e